import React, { useEffect, useState } from 'react';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Writing from './components/Writing';
import Skills from './components/Skills';
import Contact from './components/Contact';
import ThemeToggle from './components/ThemeToggle';
import BusFactorBlog from './blog/BusFactorBlog';
import MehngaiBlog from './blog/MehngaiBlog';

function useHashRoute() {
    const [hash, setHash] = useState(() => window.location.hash);
    useEffect(() => {
        const onHash = () => {
            const next = window.location.hash;
            setHash(next);
            if (next.startsWith('#/') || next === '') {
                window.scrollTo({ top: 0 });
            }
        };
        window.addEventListener('hashchange', onHash);
        return () => window.removeEventListener('hashchange', onHash);
    }, []);
    return hash;
}

export default function App() {
    const hash = useHashRoute();

    let content;

    if (hash.startsWith('#/blog/busfactor')) {
        content = <BusFactorBlog />;
    } else if (hash.startsWith('#/blog/mehngai')) {
        content = <MehngaiBlog />;
    } else {
        content = (
            <div className="page">
            <header>
                <h1>Hritik Kumar</h1>
                <p className="handle">@devnamrits</p>
                <p>
                    Backend &amp; LLM systems engineer at PhonePe. Five years
                    into software — a year of internships, then four building
                    backend and LLM systems that run in production.
                </p>
                <p>
                    I like owning things end to end: backend design, infra,
                    evaluation tooling, and getting all of it to real traffic.
                </p>
                <p>
                    Outside work I cook — same discipline as backend
                    engineering: boring fundamentals, reliable output.
                </p>
                <p className="links">
                    <a href="mailto:devnamrits@gmail.com">email</a> ·{' '}
                    <a href="https://github.com/devnamrits" target="_blank" rel="noreferrer">
                        github
                    </a>{' '}
                    ·{' '}
                    <a href="https://www.linkedin.com/in/devnamrits/" target="_blank" rel="noreferrer">
                        linkedin
                    </a>
                </p>
            </header>

            <Experience />
            <Projects />
            <Writing />
            <Skills />
            <Contact />

            <footer>© 2026 Hritik Kumar</footer>
            </div>
        );
    }

    return (
        <>
            <ThemeToggle />
            {content}
        </>
    );
}
